import React from 'react';
import CombatActionPanel from '../../CombatActionPanel/index.js';
export default function CombatView({ combatDetail, game, rules, scenario, actionPanelRef, hideCombatDetail, actionPanelStyleProps, }) {
    const getCombat = (combatId) => game.state?.combats?.find((c) => c.id === combatId);
    if (!combatDetail.isVisible) {
        return null;
    }
    let handleOnClose = () => { };
    let combat = null;
    if (combatDetail.isVisible) {
        handleOnClose = () => hideCombatDetail();
        combat = getCombat(combatDetail.combatId) ?? null;
    }
    if (!combat) {
        return null;
    }
    return (React.createElement("div", { className: "action-panel", ref: actionPanelRef, style: actionPanelStyleProps },
        React.createElement(CombatActionPanel, { combat: combat, rules: rules, gameState: game.state, scenario: scenario, hexes: game.hexes, onClose: () => handleOnClose() })));
}
